import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './App.css';
import LoginPage from './view/LoginPage';
import { AuthProvider } from './context/AuthContext';
import AdminDashboard from './view/AdminDashboard';
import ManagerDashboard from './view/ManagerDashboard';
import { LoadScript } from '@react-google-maps/api';
import SeoDashboard from './view/SeoDashboard';
import { ToastContainer } from 'react-toastify';

const libraries = ['places'];

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <LoadScript  googleMapsApiKey="AIzaSyCynnx-IyCLIQ8txBHwKNjMOb1DON6WK_U" libraries={libraries} >
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginPage/>} />
                    <Route path="/login" element={<LoginPage/>} />
                    <Route path="/admin-dashboard" element={<AdminDashboard/>} />
                    <Route path="/manager-dashboard" element={<ManagerDashboard/>} />
                    <Route path="/executive-dashboard" element={<ManagerDashboard/>} />
                    <Route path="/seo-dashboard" element={<SeoDashboard/>} />                          
                    <Route path="/unauthorised" element={<LoginPage/>} />
                </Routes>
            </Router>
        </AuthProvider>
      </LoadScript>
    </div>     
  );
}

export default App;
